import Swiper, { Navigation, Pagination } from 'swiper'

export class ElementSlider {

  constructor (element) {

    this.slider = this.init(element)

  }

  init(element) {

    if ($(element).find('.swiper-slide').length) {

      return new Swiper(element, {
        modules: [Navigation, Pagination],
        slidesPerView: 'auto',
        freeMode: true,
        loop: true,
        navigation: {
          nextEl: element + ' .element-slider-next',
          prevEl: element + ' .element-slider-prev'
        },
        pagination: {
          el: element + ' .swiper-pagination',
          type: "fraction",
          renderFraction: function (currentClass, totalClass) {
            return `<span class="${currentClass}"></span><span>/</span><span class="${totalClass}"></span>`
          }
        },
        breakpoints: {
          1200: {
            slidesPerView: "auto",
          },
        }
      })

    }

  }

  destroy() {

    if(this.slider) {
      this.slider.destroy(true, true)
    }
  }

}
